<template>
  <div class="locked-screen">
    <div class="dashboard-header flex-between flex-v-center">
      <img alt="logo" src="./../assets/img/logo-new.svg" class="logo">
      <button @click.prevent="runParentPassForm(null)" class="btn btn-main -shadow">{{$lang.messages.exit_kids_mode}}</button>
    </div>
    <div class="dashboard-text-section">
      <div class="locked-screen-title text-center mb-1">
        <span>{{$lang.messages.kids_mode_on}}</span>
      </div>
      <p class="text-center locked-screen-subtitle">
        <span>{{$lang.messages.kids_mode_on_description}}</span>
      </p>
    </div>
    <div class="locked-profiles" v-if="profiles">
      <div>
        <span v-if="isFromSwitchProfile" class="flex-v-center pointer" @click="back">
          <svg class="rotate-180 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
            </svg>
          Back
        </span>
        <div class="locked-title">{{$lang.messages.select_kid}}</div>
        <div class="locked-profile-list">
          <div v-for="(profile, index) in profilesToshow" :key="index" class="locked-profile pointer" :class="{'-already-active' : activeProfiles.includes(index)}" @click="chooseProfile(index)">
            <div class="locked-profile-image">
              <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="avatar">
            </div>
            <div class="locked-profile-name">
              {{profile.kidName || 'Kid'}} <br>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-between flex-v-center flex-column-xs">
        <div class="locked-parent-profile pointer" @click.prevent="runParentPassForm(true)">
            <div class="locked-parent-profile-image">
              <img src="../assets/img/parent-profile.svg" alt="parent dashboard">
            </div>
            <div class="locked-parent-profile-name">
              {{$lang.messages.parent_dashboard}}
            </div>
        </div>
        <span class="why-link">
          {{$lang.messages.why_i_see_this}}
          <span class="dialog">
            {{$lang.messages.choose_account}}
          </span>
        </span>
      </div>
    </div>
    <EnterParentPassword
        v-if="showParentPassword"
        :passToCheck="settings.password"
        @onBackClick="showParentPassword = false; openDashboardTab = null;"
        @submitSuccess="onParentPasswordPass"
    />
    <EnterParentPassword
        v-if="showKidPassword"
        :passToCheck="kidPass"
        @onBackClick="showKidPassword = false"
        @submitSuccess="onKidPasswordPass"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import saveSetting from "@/components/mixins/saveSetting";
import EnterParentPassword from "@/components/EnterParentPassword"
import {reportEvent} from "../helpers/utils";

export default {
  name: 'Locked',
  mixins: [saveSetting],
  data: function () {
    return {
      showPasswordBlock: false,
      activeProfile: 0,
      enteredPassword: '',
      errorInPassword: false,
      goToParent: false,
      showForgot: false,
      showHelpBlock: false,
      openDashboardTab: null,
      passToCheck: null,
      showParentPassword: false,
      showKidPassword: false,
      isFromSwitchProfile: this.$route.query.switch,
    }
  },
  computed: {
    ...mapState({
      profiles: state => state.accountData.profiles,
      user: state => state.user,
      settings: state => state.accountData,
      currentDeviceID: state => state.currentDeviceID,
    }),
    profilesToshow() {
      if (!this.settings.isPremium) {
        return {
          defaultProfileSettings: this.profiles.defaultProfileSettings
        }
      }
      return this.profiles;
    },
    activeProfiles() {
      const activeProfilesArray = [];
      Object.keys(this.settings.devices).forEach(key => {
        const profileIdAtDevice = this.settings.devices[key].currentProfileID;
        if (profileIdAtDevice) {
          activeProfilesArray.push(profileIdAtDevice);
        }
      })
      return activeProfilesArray;
    },
    kidPass() {
      if (this.activeProfile) {
        return this.profiles[this.activeProfile].kidPassword;
      }
      return null;
    }
  },
  methods: {
    back(){
      this.chooseProfile(this.isFromSwitchProfile);
    },
    onParentPasswordPass() {
      this.exitKidsMode(this.currentDeviceID, this.openDashboardTab);
    },
    onKidPasswordPass() {
      this.saveDeviceSettings(this.currentDeviceID, {currentProfileID: this.activeProfile})
          .then(() => {
            this.$router.push('/kid')
          });
    },
    chooseProfile(profileID){
      const isAlreadyActiveProfiles = this.activeProfiles.includes(profileID);

      if (isAlreadyActiveProfiles) {
        this.$dtoast.pop({
          preset: "error",
          heading: "This account already active at other device",
        })
      } else {
        this.activeProfile = profileID;
        if (this.profiles[this.activeProfile].kidPassword) {
          this.showKidPassword = true;
        } else {
          this.onKidPasswordPass();
        }
      }
    },
    runParentPassForm(openDashboardTab) {
      this.openDashboardTab = openDashboardTab;
      this.showParentPassword = true;
    },
    exitKidsMode(deviceID, openDashboardTab) {
      reportEvent('exitKidsMode', {
        isRemote: false,
        exitFromLockedScreen: true,
      });
      this.saveDeviceSettings(deviceID, {
        locked: false,
        openDashboardTab,
      })
    },
  },
  components: {
    EnterParentPassword
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.locked-title {
  font-size: 30px;
  font-weight: 600;
  text-align: center;

  @include responsive-below($sm){
    font-size: 24px;
  }
}

.locked {
  &-screen {
    &-title {
      padding: 0 20px;
      font-size: 64px;
      color: #7D6AED;
      font-weight: 600;
      text-transform: uppercase;

      @include responsive-below($md){
        font-size: 48px;
      }
      @include responsive-below($sm){
        font-size: 36px;
      }

      @include responsive-below($xs){
        font-size: 24px;
        padding: 0;
      }
    }

    &-subtitle {
      padding: 0 20px;
    }
  }
  &-profile {
    margin: 10px;
    text-align: center;
    width: 100px;

    @include responsive-below($xs){
      width: 85px;
    }

    &.-already-active {
      opacity: 0.3;
    }

    &-list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      overflow: auto;
      max-height: 450px;

      @include responsive-below($sm){
        flex-wrap: nowrap;
        justify-content: flex-start;
        margin: 0 -30px;
      }

      @include responsive-below-height('900px'){
        max-height: 40vh;
      }
    }

    &-image {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      margin: 10px auto;
      background: #EBEFF5;
      padding: 10px;
      box-shadow: 0 1px 0 rgba(255, 255, 255, 0.3), inset 0 1px 0.72px rgba(0, 0, 0, 0.2);
      cursor: pointer;

      @include responsive-below($sm){
        width: 75px;
        height: 75px;
      }

      &.active {
        box-shadow: 0 0 0 3px #FFD02A;
      }

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }

    &-name {
      font-weight: 600;
      font-size: 16px;
      color: #fff;
      max-width: 100%;
      text-overflow: ellipsis;
      word-break: break-word;
    }
  }

  &-profiles {
    background: #EFF0F9;
    box-shadow: 0px 100px 80px rgba(206, 183, 171, 0.3), 0px 41.7776px 33.4221px rgba(206, 183, 171, 0.0503198), 0px 22.3363px 17.869px rgba(206, 183, 171, 0.0417275), 0px 12.5216px 10.0172px rgba(206, 183, 171, 0.035), 0px 6.6501px 5.32008px rgba(206, 183, 171, 0.0282725), 0px 2.76726px 2.21381px rgba(206, 183, 171, 0.0196802);
    border-radius: 24px 24px 0 0;
    width: 774px;
    max-width: calc(100% - 16px);
    margin: 40px auto 0 auto;
    flex: 1;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;

    @include responsive-below($sm){
      margin: 20px 8px 0;
    }

    @include responsive-below-height('800px'){
      margin-top: 20px;
    }

    &:before {
      content: '';
      display: block;
      width: 300px;
      height: 166px;
      background: url("../assets/img/locked-arrow.svg") center/contain no-repeat;
      position: absolute;
      left: -200px;
      top: -180px;

      @include responsive-below($sm){
        display: none;
      }
    }

    .locked-profile {
      margin: 20px;
      width: 150px;

      @include responsive-below($xs){
        width: 120px;
        margin: 8px;
      }

      &-name {
        color: #443AA2;
      }

      &-image {
        width: 140px;
        height: 140px;

        @include responsive-below($xs){
          width: 100px;
          height: 100px;
        }
      }
    }
  }

  &-screen {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #FBF5F2 url("../assets/img/locked-new-bg.svg") no-repeat center/cover;
  }
}

.locked-parent-profile {
  background: #A49DFF;
  border-radius: 60px;
  display: inline-flex;
  align-items: center;
  padding: 5px 15px 5px 5px;
  margin-bottom: 18px;
  transition: all 0.3s;

  @include responsive-below($sm){
    margin-bottom: 0;
  }

  &:hover {
    background: #877EF4;;
  }

  &-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
  }

  &-name {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }
}

.locked-password-block {
  padding-top: 50px;
  max-width: 330px;
  margin: 0 auto;
  text-align: center;

  &-links {
    margin: 38px 0 56px;
    color: #fff;
  }

  &-link {
    color: #DFE6FF;
    font-style: italic;
    cursor: pointer;
    display: inline-block;
    margin: 0 15px;
  }

  .login-pass {
    color: #fff;
    font-weight: 400;
  }

  &-btn .btn {
    border: none;
    color: #7D6AED;
    
    &:hover {
      background-color: #DFE6FF;
    }
    
    svg {
      width: 12px;
      margin-right: 10px;
      vertical-align: -5px;
    }
  }
}

.why-link {
  font-size: 20px;
  font-weight: 700;
  color: #193AAD;
  cursor: pointer;
  text-align: center;
  position: relative;

  @include responsive-below($sm){
    bottom: 10px;
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
  }

  &:hover {
    .dialog {
      visibility: visible;
      opacity: 1;
    }
  }
}

.dialog {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  position: absolute;
  padding: 26px 34px;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  color: #413B3D;
  font-weight: 400;
  bottom: calc(100% + 20px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 315px;

  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: calc(100% - 15px);
    transform: translateX(-50%) rotate(45deg);
    width: 26px;
    height: 26px;
    background: #fff;
    border-bottom-right-radius: 8px;
  }
}

.dashboard-wrapper {
  &--locked {
    @include responsive-below($sm) {
      .dashboard-content {
        background: linear-gradient(180deg, #A39CFF 0%, #CDE4FF 100%), linear-gradient(180deg, #E0E1EF 0%, rgba(224, 225, 239, 0) 100%);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }

    .dashboard-header {
      @include responsive-below($sm){
        box-shadow: 0px 1px 1px rgba(159, 129, 248, 0.16);
      }
    }

    .dashboard-text-section {
      margin: 30px 0;
      padding: 0 15px;
    }
  }
}

</style>
